import ErrorHandler from '@schachermayer/sch-vuejs-commons/src/errors';
import { GoogleTagManagerApi } from '../../build/swagger-code-extranet-api-definition/apis/google-tag-manager-api';

export interface GoogleTagManagerEvent {
    event: string;
    [key: string]: unknown;
}

declare global {
    interface Window {
        dataLayer: GoogleTagManagerEvent[];
    }
}

const googleTagManagerApi: GoogleTagManagerApi = new GoogleTagManagerApi({
    basePath: process.env.VUE_APP_CONTEXT_BASE,
});

export class GoogleTagManagerService {
    public static async getGoogleTagManagerId(): Promise<string | null> {
        try {
            const response = await googleTagManagerApi.getGoogleTagManagerId({
                credentials: 'same-origin',
            });

            return response.data.id;
        } catch (e) {
            await ErrorHandler.handleError(e);
            return null;
        }
    }

    public static setupDataLayer(): void {
        window.dataLayer = window.dataLayer || [];
    }

    public static pushEvent(event: GoogleTagManagerEvent): void {
        if (window.dataLayer != null) {
            window.dataLayer.push(event);
        }
    }
}
